import { Component, OnInit } from '@angular/core';
import { AuthMethodService } from 'src/app/services/auth-method.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from './../../../models/Constants';
import { ApiService } from 'src/app/services/api.service';
import { LogService } from 'src/app/services/log.service';

@Component({
  selector: 'app-pin-reset-panel',
  templateUrl: './pin-reset-panel.component.html',
  styleUrls: ['./pin-reset-panel.component.scss']
})


export class PinResetPanelComponent implements OnInit {
  errorDescription: any;

  emailList: any;
  postalAddress: any;
  allMethodDisabled: boolean = false;
  fileName: string = "pin-reset-panel_component";
  // deliveryOption: string | undefined;
  constructor(public rootScope: RootScopeService, public authService: AuthMethodService, public apiService: ApiService,
    public logger: LogService
  ) {
   
  }

  ngOnInit(): void {
    this.getMethods();
  }


  selectedMethod(SelecetedData) {
    this.logger.infoLogs("Selected Delivery Method for customerSessionId"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
    this.rootScope.deliveryOption = SelecetedData
  }

  /*
@Author:Amarjeet
pinResetContinueStep1() called to get address from Sauth
CCR3-7070
*/
  pinResetContinueStep1() {
    // temp-address tba link logic
    if (this.rootScope?.pinRestTbaGuipostDetails) {
      this.rootScope.tempAddressEnabled = true;
    } else {
      this.rootScope.tempAddressEnabled = false;
    }
    this.getAddress();
    this.logger.infoLogs("step1Active in PIN_RESET for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
  }


  /*
 @Author:Hashid
 pinResetEmailBackStep2() called to go on previous step 1
 CCR3-6236
 */
  pinResetEmailBackStep2() {
    this.rootScope.activeCustTab.pinReset.step1Active = true;
    this.rootScope.activeCustTab.pinReset.step1Complete = false;
    this.rootScope.activeCustTab.pinReset.step2Active = false;
    this.rootScope.activeCustTab.pinReset.step2Failed = false;
    this.logger.infoLogs("PINRESET step back for selecting delivery Method", this.fileName);
  }

  /*
 @Author:Hashid
 pinResetEmailContinueStep2() called to go on next step 3
 CCR3-6236
 */
  pinResetEmailContinueStep2() {
    this.rootScope.activeCustTab.pinReset.step2Active = false;
    this.rootScope.activeCustTab.pinReset.step2Complete = true;
    this.rootScope.activeCustTab.pinReset.step3Active = true;
    this.logger.infoLogs("PIN_RESET step2Active for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
  }

  /*
@Author:Hashid
pinResetEmailBackStep3() called to go on previous step 2
CCR3-6236
*/
  pinResetEmailBackStep3() {
    this.rootScope.activeCustTab.pinReset.step2Active = true;
    this.rootScope.activeCustTab.pinReset.step2Complete = false;
    this.rootScope.activeCustTab.pinReset.step3Active = false;
    this.rootScope.activeCustTab.pinReset.step3Failed = false;
    this.logger.infoLogs("PIN_RESET step3 Back for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
  }

  /*
@Author:Hashid
sendPinEmail() called to send email to sauth
CCR3-6236
*/
  sendPinEmail() {
    this.sentPinResetMethod();
  }

  /*
@Author:Amarjeet
getAddress() called to go on next step 3
CCR3-7070
*/
  pinResetContinueStep2() {
    this.rootScope.activeCustTab.pinReset.step2Active = false;
    this.rootScope.activeCustTab.pinReset.step2Complete = true;
    this.rootScope.activeCustTab.pinReset.step3Active = true;
    this.logger.infoLogs("PIN_RESET step3Active for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
  }

  /*
@Author:Amarjeet
getAddress() called to go on previous step 1
CCR3-7070
*/
  pinResetBackStep2() {
    this.rootScope.activeCustTab.pinReset.step1Active = true;
    this.rootScope.activeCustTab.pinReset.step1Complete = false;
    this.rootScope.activeCustTab.pinReset.step2Active = false;
    this.rootScope.activeCustTab.pinReset.step2Failed = false;
    this.logger.infoLogs("PIN_RESET step1Active from Step2 for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
  }
  /*
@Author:Amarjeet
getAddress() called to go on previous step 2
CCR3-7070
*/
  pinResetBackStep3() {
    this.rootScope.activeCustTab.pinReset.step2Active = true;
    this.rootScope.activeCustTab.pinReset.step2Complete = false;
    this.rootScope.activeCustTab.pinReset.step3Active = false;
    this.rootScope.activeCustTab.pinReset.step3Failed = false;
    this.logger.infoLogs("PIN_RESET step2Active from Step3 for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
  }

  /*
@Author:Amarjeet
sendPin() called to send the pin to Sauth using postal delivery method
CCR3-7070
*/
  sendPin() {
    this.sentPinResetMethod();
  }

  /*
  @Author:Jaya
  getMethods() called to get Delivery Method i.e. "Postal/Email"
  CCR3-7623
  */
  getMethods() {
    let activetab = this.rootScope.activeCustTab;
    let deliveryMethodDetail = this.rootScope.deliveryMethodsMap.get(activetab.clientId);
    //this.rootScope.deliveryMethodsMap.get("BASE")-Need to check if required for base client.
  
    if (deliveryMethodDetail) {
      this.logger.infoLogs("Get PIN_RESET Delivery Method Details Function triggered for customerSessionId: "+this.rootScope.activeCustTab.customerSessionId,this.fileName);
      deliveryMethodDetail = JSON.parse(deliveryMethodDetail);
      if (activetab.deliveryMethod.length == 0){
        [{ label: "Postal address", disabled: "true", name: "postal_enabled", value: "postal" }, { label: "Email address", disabled: "true", name: "email_enabled", value: "email" }].forEach((element, index) => {
          if (deliveryMethodDetail?.[element.name]) {
            element.disabled = deliveryMethodDetail?.[element.name] == "true" ? "false" : "true";
            this.rootScope.activeCustTab.deliveryMethod.push(element);
          }
          else {
            this.rootScope.activeCustTab.deliveryMethod.push(element);
          }
        });
      }
      if (!this.rootScope.deliveryOption) {
        if (this.rootScope.activeCustTab.deliveryMethod[0]?.disabled == "false") {
          this.rootScope.deliveryOption = this.rootScope.activeCustTab.deliveryMethod[0]?.value;

        }
        else if (this.rootScope.activeCustTab.deliveryMethod[1]?.disabled == "false") {
          this.rootScope.deliveryOption = this.rootScope.activeCustTab.deliveryMethod[1]?.value;
        }
      }
    }
    else {
      this.rootScope.activeCustTab.deliveryMethod = [];
    }

    this.allMethodDisabled = this.rootScope.activeCustTab.deliveryMethod.every(x => x.disabled == "true")
  }

  /*
 @Author:Amarjeet
 getAddress() called to get address from Sauth
 CCR3-7070
 */
  getAddress() {
    let reqBody = {
      deliveryMethod: this.rootScope.deliveryOption,
      clientId: this.rootScope.activeCustTab.clientId
    }
    this.logger.infoLogs("PIN_RESET Get Address API Request triggered for CustomerSessionId"+this.rootScope.activeCustTab.customerSessionId,this.fileName);

    this.authService.getAddress(reqBody, this.rootScope.activeCustTab.customerSessionId).subscribe({
      next: (data: any) => {
        if (data && data?.data) {
          const parsedLanguages = JSON.parse(data?.data);
          this.logger.debugLogs("PIN_RESET Get Address API response for customerSessionId"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
          if (this.rootScope.deliveryOption == "postal") {
            //  this.postalAddress
            let addressData = parsedLanguages?.credentialCommunicationPostalAddrList?.[0];
            if (addressData == undefined || addressData == '' || addressData?.length == 0) {
              this.rootScope.activeCustTab.pinReset.step1Active = false;
              this.rootScope.activeCustTab.pinReset.step1Complete = true;
              this.rootScope.activeCustTab.pinReset.step2Failed = true;
              this.rootScope.pinRestErrorMsg = Constants.PINRESET_MESSAGES.NO_VALID_POSTAL_AVAILABLE;
              return;
            } else {
              this.rootScope.postalAddress = (addressData.addr_LINE_1_TX + ' ' + addressData.addr_LINE_2_TX + ' ' + addressData.addr_LINE_3_TX + ' ' + addressData.addr_LINE_4_TX).trim() + ", " + addressData.city_NM + ", " + addressData.st_CD + ", " + addressData.country_CD + " " + addressData.zip_CD
            }
          } else {
            this.rootScope.emailList = parsedLanguages?.credentialCommunicationEmailAddrList?.[0];
            if (this.rootScope.emailList == undefined || this.rootScope?.emailList == '' || this.rootScope.emailList?.length == 0) {
              this.rootScope.activeCustTab.pinReset.step1Active = false;
              this.rootScope.activeCustTab.pinReset.step1Complete = true;
              this.rootScope.activeCustTab.pinReset.step2Failed = true;
              this.rootScope.pinRestErrorMsg = Constants.PINRESET_MESSAGES.NO_VALID_MAIL_AVAILABLE;
              return;
            }
          }
          this.rootScope.activeCustTab.pinReset.step1Active = false;
          this.rootScope.activeCustTab.pinReset.step1Complete = true;
          this.rootScope.activeCustTab.pinReset.step2Active = true;
        }

      },
      error: (error) => {
        this.rootScope.activeCustTab.pinReset.step1Active = false;
        this.rootScope.activeCustTab.pinReset.step1Complete = true;
        this.rootScope.activeCustTab.pinReset.step2Failed = true;
        this.errorDescription = error.error?.errorResponse?.errorDescription?.trim();
        this.pinRestErrorHandler();
        this.logger.errorLogs(JSON.stringify(error), this.fileName);
      }

    })
  }

  /**
   * @author:Hashid
   * method used compare the error code from sauth response and and valid value table and dynamically managing error
   * messages for postal & email delivery methods.
   * 
   */
  pinRestErrorHandler() {
    let errorMsgObjc = this.rootScope.pinResetErrorList?.find(item => item?.fieldValue.trim() === this.errorDescription);
    this.rootScope.pinRestErrorMsg = errorMsgObjc?.fieldValueDescription;
    if (this.rootScope.pinRestErrorMsg == null || this.rootScope.pinRestErrorMsg == undefined) {
      this.rootScope.pinRestErrorMsg = Constants.PINRESET_MESSAGES.TECHNICAL_ISSUE_METHOD_NOT_AVAILBLE;
    }
  }

  /*
@Author:Hashid
sentPinResetMethod() called to send email to sauth
CCR3-6236
*/
  sentPinResetMethod() {
    let reqBody = {
      deliveryMethod: this.rootScope.deliveryOption,
      clientId: this.rootScope.activeCustTab.clientId,
      globalIdentifierId: this.rootScope.activeCustTab.id
    }
    this.logger.infoLogs("Sent Pin Reset Method delivery method Request for customerSessionId"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
    
    this.authService.sentPinEmailPostal(reqBody, this.rootScope.activeCustTab.customerSessionId).subscribe({
      next: (data: any) => {
        /* istanbul ignore next */
        if (data && !(data == undefined || data == '' || data?.length == 0)) {
          if (this.rootScope.deliveryOption == "postal") {
            this.rootScope.activeCustTab.pinReset.step3Active = false;
            this.rootScope.activeCustTab.pinReset.step3Failed = false;
            this.rootScope.activeCustTab.pinReset.step3Complete = true;
          }
          else {
            this.rootScope.activeCustTab.pinReset.step3Active = false;
            this.rootScope.activeCustTab.pinReset.step3Failed = false;
            this.rootScope.activeCustTab.pinReset.step3Complete = true;
          }
          this.rootScope.peaAuthUserDetails.next(true);
          this.logger.debugLogs("Received Pin Reset delivery Method Response"+JSON.stringify(data),this.fileName);

        }
        else {
          this.rootScope.activeCustTab.pinReset.step1Active = false;
          this.rootScope.activeCustTab.pinReset.step1Complete = true;
          this.rootScope.activeCustTab.pinReset.step2Active = false;
          this.rootScope.activeCustTab.pinReset.step2Complete = true;
          this.rootScope.activeCustTab.pinReset.step3Active = false;
          this.rootScope.activeCustTab.pinReset.step2Failed = false;
          this.rootScope.activeCustTab.pinReset.step3Failed = true;
          this.rootScope.pinRestErrorMsg = Constants.PINRESET_MESSAGES.TECHNICAL_ISSUE_METHOD_NOT_AVAILBLE;
          return;
        }

      },
      error: (error) => {
        this.rootScope.activeCustTab.pinReset.step1Active = false;
        this.rootScope.activeCustTab.pinReset.step1Complete = true;
        this.rootScope.activeCustTab.pinReset.step2Active = false;
        this.rootScope.activeCustTab.pinReset.step2Complete = true;
        this.rootScope.activeCustTab.pinReset.step3Active = false;
        this.rootScope.activeCustTab.pinReset.step3Failed = true;
        this.rootScope.activeCustTab.pinReset.step2Failed = false;
        this.errorDescription = error.error?.errorResponse?.errorDescription?.trim();
        this.pinRestErrorHandler();
        this.logger.errorLogs(JSON.stringify(error), this.fileName);

      },

    })
  }


  /**
   * Link method which will open the tba gui to update the temp address for pin reset method
   * by passing fastpath and action value etc.
   * @author HASHID
   */
  goToTempAddressTbaGui() {
    this.rootScope.selectedLeftNavBarLink(this.rootScope?.pinRestTbaGuipostDetails, true);
    this.logger.infoLogs("TBA GUI Link for temp address opened for customerSessionId:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
  }

  /**
   * @author HASHID
   * method helps to update the postal address into 2nd step of pin reset when agent updated the temp address
   * through tba gui.
   */
  refreshTempAddress() {
    this.getAddress();
  }


}
